import type {Node} from 'prosemirror-model';
import { Transaction, TextSelection } from "prosemirror-state";
import { TableRect } from "prosemirror-tables";

export const insertRow = (tr: Transaction, tableRect: TableRect, targetPos: number, tableHeight: number) => {
    let { map, tableStart, table } = tableRect;
    let pos = tableStart;

    for (let h = 0; h < targetPos; h++) {
        pos += table.child(h).nodeSize;
    }

    const { schema } = table.type;
    const cellNode = schema.nodes.tableDataCell;
    const rowNode = schema.nodes.tableRow;

    const rows = [];
    for (let h = 0; h < tableHeight; h++) {
        const cells: Node[] = [];
        for (let t = 0; t < map.width; t++) {
            cells.push(cellNode.createAndFill()!);
        }
        rows.push(rowNode.create(null, cells));
    }

    tr.insert(pos, rows);
    tr.setSelection(TextSelection.near(tr.doc.resolve(pos)));
    return tr;
}